import { getFormalOfferByLoanOfferId } from '@helpers/FormalOffers/getFormalOfferByLoanOfferId';
import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';

export type TOfferSetType =
    // Take more funds, keep current duration
    | 'more_funds_only'
    // Take more funds, choice between keeping current duration or access period
    | 'more_funds_with_repayment_choice'
    // Duration reset
    | 'repayment_reduction_only'
    // Choice between interest only period or duration reset (or duration change)
    | 'repayment_reduction_with_choice'
    // Unknown offer set type
    | null;

type TOffers = GetFormalOffersResponse['data']['formal_offers'];

export const getOfferSetType = (
    offers: TOffers,
    loanOfferId: string
): TOfferSetType => {
    if (offers.length === 1) {
        if (offers[0].is_repayment_reduction) {
            return 'repayment_reduction_only';
        } else {
            return 'more_funds_only';
        }
    }

    if (offers.length > 1) {
        if (offers.some((offer) => offer.is_repayment_reduction)) {
            return 'repayment_reduction_with_choice';
        } else {
            const partiallyDrawnDownOffer = getFormalOfferByLoanOfferId(
                offers,
                loanOfferId
            );

            // If an offer has already been drawn down on, a different offer in the same set cannot be drawn down on. Therefore we only want to show the customer their drawn down offer.
            // This only applies to offers with available cash, since cashless offers can not be drawn down on more than once.
            if (partiallyDrawnDownOffer) {
                return 'more_funds_only';
            }

            return 'more_funds_with_repayment_choice';
        }
    }

    return null;
};
